import React from 'react';
import { type Argument, cs } from '@bbkAdminUtils/css-utils';
import icons from '@bbkAdminUtils/icons';
import './styles/link_group.scss';

// Interior to a row item
type Props = {
  item: {
    icon?: keyof typeof icons;
    iconClasses?: Argument;
    text: React.ReactNode;
    itemClasses?: Argument;
  };
};
const LinkGroupItem: React.FC<Props> = (props) => {
  const { item } = props;
  return (
    <div className="bbk-lg-i">
      {item.icon && (
        <span className={cs('bbk-lg-i-i', item.iconClasses)}>
          {icons[item.icon]}
        </span>
      )}
      <div className={cs('bbk-lg-i-t', item.itemClasses)}>{item.text}</div>
    </div>
  );
};

export default LinkGroupItem;
